export default {
  async fetch({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setAudits");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setAudits({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    try {
      const audits = await this.$services.audit.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_AUDIT_ENTRIES", audits);
    } catch (error) {
      throw new Error(error);
    }
  },

  async fetchAudit({ commit }, uuid) {
    try {
      const audit = await this.$services.audit.fetchOne(uuid);
      commit("SET_VIEWING_AUDIT", audit);
    } catch (error) {
      throw new Error(error);
    }
  },

  async prepareCsv({ dispatch, commit }, params) {
    try {
      await this.$services.audit.preparecsv(params);
      await dispatch("application/setDownloads", {}, { root: true });
      commit("application/SET_IS_WAITING_FOR_DOWNLOADS", true, { root: true });
      this.$feedback.ok("generic.download.ok");
    } catch {
      this.$feedback.error("generic.download.error");
    }
  },
};
